import { FilterValue } from "../Filters/FilterValue";

export const DispatchDateFilterType: FilterValue[] = [
  { id: "1", value: "Dispatch Today/Missed" },
  { id: "2", value: "Dispatch In 1-3 Days" },
  { id: "3", value: "Dispatch In 4-7 Days" },
  { id: "4", value: "Dispatch In 7+ Days" },
];
